import { render, staticRenderFns } from "./DateRule.vue?vue&type=template&id=01586323&"
import script from "./DateRule.vue?vue&type=script&lang=ts&"
export * from "./DateRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports